

const roleDependencies = {
  "rep_all_access": [],
  "rep_all_lm-admin-access": ["rep_all_access"],
  "rep_all_ta-admin-access": ["rep_all_access"],
  "rep_all_tg-admin-access": ["rep_all_access"],
  "rep_lm-internal-activity-coreg_drilldown": ["rep_lm-internal-activity-coreg_report"],
  "rep_lm-internal-activity-coreg_export": ["rep_lm-internal-activity-coreg_report"],
  "rep_lm-internal-activity-coreg_no-email": ["rep_lm-internal-activity-coreg_report"],
  "rep_lm-internal-activity-coreg_report": ["rep_all_access"],
  "rep_lm-internal-activity-coreg_scheduler": ["rep_lm-internal-activity-coreg_report"],
  "rep_lm-internal-activity-cto_drilldown": ["rep_lm-internal-activity-cto_report"],
  "rep_lm-internal-activity-cto_export": ["rep_lm-internal-activity-cto_report"],
  "rep_lm-internal-activity-cto_no-email": ["rep_lm-internal-activity-cto_report"],
  "rep_lm-internal-activity-cto_report": ["rep_all_access"],
  "rep_lm-internal-activity-cto_scheduler": ["rep_lm-internal-activity-cto_report"],
  "rep_lm-internal-activity-submissions_drilldown": ["rep_lm-internal-activity-submissions_report"],
  "rep_lm-internal-activity-submissions_export": ["rep_lm-internal-activity-submissions_report"],
  "rep_lm-internal-activity-submissions_no-email": ["rep_lm-internal-activity-submissions_report"],
  "rep_lm-internal-activity-submissions_report": ["rep_all_access"],
  "rep_lm-internal-activity-submissions_scheduler": ["rep_lm-internal-activity-submissions_report"],
  "rep_lm-lead-gen_drilldown": ["rep_lm-lead-gen_report"],
  "rep_lm-lead-gen_export": ["rep_lm-lead-gen_report"],
  "rep_lm-lead-gen_no-email": ["rep_lm-lead-gen_report"],
  "rep_lm-lead-gen_report": ["rep_all_access"],
  "rep_lm-lead-gen_scheduler": ["rep_lm-lead-gen_report"],
  "rep_lm-leads_drilldown": ["rep_lm-leads_report"],
  "rep_lm-leads_export": ["rep_lm-leads_report"],
  "rep_lm-leads_no-email": ["rep_lm-leads_report"],
  "rep_lm-leads_report": ["rep_all_access"],
  "rep_lm-leads_scheduler": ["rep_lm-leads_report"],
  "rep_lm-links-clicked_drilldown": ["rep_lm-links-clicked_report"],
  "rep_lm-links-clicked_export": ["rep_lm-links-clicked_report"],
  "rep_lm-links-clicked_no-email": ["rep_lm-links-clicked_report"],
  "rep_lm-links-clicked_report": ["rep_all_access"],
  "rep_lm-links-clicked_scheduler": ["rep_lm-links-clicked_report"],
  "rep_lm-submissions_export": ["rep_lm-submissions_report"],
  "rep_lm-submissions_no-email": ["rep_lm-submissions_report"],
  "rep_lm-submissions_report": ["rep_all_access"],
  "rep_lm-submissions_scheduler": ["rep_lm-submissions_report"],
  "rep_ta-dashboard_drilldown": ["rep_ta-dashboard_report"],
  "rep_ta-dashboard_export": ["rep_ta-dashboard_report"],
  "rep_ta-dashboard_no-email": ["rep_ta-dashboard_report"],
  "rep_ta-dashboard_report": ["rep_all_access"],
  "rep_ta-dashboard_scheduler": ["rep_ta-dashboard_report"],
  "rep_ta-email-performance_export": ["rep_ta-email-performance_report"],
  "rep_ta-email-performance_report": ["rep_all_access"],
  "rep_ta-fe-unique-summary_export": ["rep_ta-fe-unique-summary_report"],
  "rep_ta-fe-unique-summary_report": ["rep_all_access"],
  "rep_ta-fe-unique-summary_scheduler": ["rep_ta-fe-unique-summary_report"],
  "rep_ta-leads_drilldown": ["rep_ta-leads_report"],
  "rep_ta-leads_export": ["rep_ta-leads_report"],
  "rep_ta-leads_no-email": ["rep_ta-leads_report"],
  "rep_ta-leads_report": ["rep_all_access"],
  "rep_ta-leads_scheduler": ["rep_ta-leads_report"],
  "rep_ta-ltv_export": ["rep_ta-ltv_report"],
  "rep_ta-ltv_report": ["rep_all_access"],
  "rep_ta-ltv_scheduler": ["rep_ta-ltv_report"],
  "rep_ta-product-sales_export": ["rep_ta-product-sales_report"],
  "rep_ta-product-sales_no-email": ["rep_ta-product-sales_report"],
  "rep_ta-product-sales_report": ["rep_all_access"],
  "rep_ta-product-sales_scheduler": ["rep_ta-product-sales_report"],
  "rep_ta-refund-rate_drilldown": ["rep_ta-refund-rate_report"],
  "rep_ta-refund-rate_export": ["rep_ta-refund-rate_report"],
  "rep_ta-refund-rate_report": ["rep_all_access"],
  "rep_ta-refund-rate_scheduler": ["rep_ta-refund-rate_report"],
  "rep_ta-sales-after-lead_export": ["rep_ta-sales-after-lead_report"],
  "rep_ta-sales-after-lead_report": ["rep_all_access"],
  "rep_ta-sales-after-lead_scheduler": ["rep_ta-sales-after-lead_report"],
  "rep_ta-sales_drilldown": ["rep_ta-sales_report"],
  "rep_ta-sales_export": ["rep_ta-sales_report"],
  "rep_ta-sales_no-email": ["rep_ta-sales_report"],
  "rep_ta-sales_report": ["rep_all_access"],
  "rep_ta-sales_scheduler": ["rep_ta-sales_report"],
  "rep_ta-submissions_export": ["rep_ta-submissions_report"],
  "rep_ta-submissions_no-email": ["rep_ta-submissions_report"],
  "rep_ta-submissions_report": ["rep_all_access"],
  "rep_ta-submissions_scheduler": ["rep_ta-submissions_report"],
  "rep_ta-transactions_export": ["rep_ta-transactions_report"],
  "rep_ta-transactions_no-email": ["rep_ta-transactions_report"],
  "rep_ta-transactions_report": ["rep_all_access"],
  "rep_ta-transactions_scheduler": ["rep_ta-transactions_report"],
  "rep_ta-webinars_drilldown": ["rep_ta-webinars_report"],
  "rep_ta-webinars_export": ["rep_ta-webinars_report"],
  "rep_ta-webinars_report": ["rep_all_access"],
  "rep_ta-webinars_scheduler": ["rep_ta-webinars_report"],
  "rep_tg-internal-activity-coreg_drilldown": ["rep_tg-internal-activity-coreg_report"],
  "rep_tg-internal-activity-coreg_export": ["rep_tg-internal-activity-coreg_report"],
  "rep_tg-internal-activity-coreg_no-email": ["rep_tg-internal-activity-coreg_report"],
  "rep_tg-internal-activity-coreg_report": ["rep_all_access"],
  "rep_tg-internal-activity-coreg_scheduler": ["rep_tg-internal-activity-coreg_report"],
  "rep_tg-internal-activity-cto_drilldown": ["rep_tg-internal-activity-cto_report"],
  "rep_tg-internal-activity-cto_export": ["rep_tg-internal-activity-cto_report"],
  "rep_tg-internal-activity-cto_no-email": ["rep_tg-internal-activity-cto_report"],
  "rep_tg-internal-activity-cto_report": ["rep_all_access"],
  "rep_tg-internal-activity-cto_scheduler": ["rep_tg-internal-activity-cto_report"],
  "rep_tg-internal-activity-submissions_drilldown": ["rep_tg-internal-activity-submissions_report"],
  "rep_tg-internal-activity-submissions_export": ["rep_tg-internal-activity-submissions_report"],
  "rep_tg-internal-activity-submissions_no-email": ["rep_tg-internal-activity-submissions_report"],
  "rep_tg-internal-activity-submissions_report": ["rep_all_access"],
  "rep_tg-internal-activity-submissions_scheduler": ["rep_tg-internal-activity-submissions_report"],
  "rep_tg-lead-gen_drilldown": ["rep_tg-lead-gen_report"],
  "rep_tg-lead-gen_export": ["rep_tg-lead-gen_report"],
  "rep_tg-lead-gen_no-email": ["rep_tg-lead-gen_report"],
  "rep_tg-lead-gen_report": ["rep_all_access"],
  "rep_tg-lead-gen_scheduler": ["rep_tg-lead-gen_report"],
  "rep_tg-leads_drilldown": ["rep_tg-leads_report"],
  "rep_tg-leads_export": ["rep_tg-leads_report"],
  "rep_tg-leads_no-email": ["rep_tg-leads_report"],
  "rep_tg-leads_report": ["rep_all_access"],
  "rep_tg-leads_scheduler": ["rep_tg-leads_report"],
  "rep_tg-links-clicked_drilldown": ["rep_tg-links-clicked_report"],
  "rep_tg-links-clicked_export": ["rep_tg-links-clicked_report"],
  "rep_tg-links-clicked_no-email": ["rep_tg-links-clicked_report"],
  "rep_tg-links-clicked_report": ["rep_all_access"],
  "rep_tg-links-clicked_scheduler": ["rep_tg-links-clicked_report"],
  "rep_tg-submissions_export": ["rep_tg-submissions_report"],
  "rep_tg-submissions_no-email": ["rep_tg-submissions_report"],
  "rep_tg-submissions_report": ["rep_all_access"],
  "rep_tg-submissions_scheduler": ["rep_tg-submissions_report"],
  "rep_sfp-internal-activity-coreg_drilldown": ["rep_sfp-internal-activity-coreg_report"],
  "rep_sfp-internal-activity-coreg_export": ["rep_sfp-internal-activity-coreg_report"],
  "rep_sfp-internal-activity-coreg_no-email": ["rep_sfp-internal-activity-coreg_report"],
  "rep_sfp-internal-activity-coreg_report": ["rep_all_access"],
  "rep_sfp-internal-activity-coreg_scheduler": ["rep_sfp-internal-activity-coreg_report"],
  "rep_sfp-internal-activity-cto_drilldown": ["rep_sfp-internal-activity-cto_report"],
  "rep_sfp-internal-activity-cto_export": ["rep_sfp-internal-activity-cto_report"],
  "rep_sfp-internal-activity-cto_no-email": ["rep_sfp-internal-activity-cto_report"],
  "rep_sfp-internal-activity-cto_report": ["rep_all_access"],
  "rep_sfp-internal-activity-cto_scheduler": ["rep_sfp-internal-activity-cto_report"],
  "rep_sfp-internal-activity-submissions_drilldown": ["rep_sfp-internal-activity-submissions_report"],
  "rep_sfp-internal-activity-submissions_export": ["rep_sfp-internal-activity-submissions_report"],
  "rep_sfp-internal-activity-submissions_no-email": ["rep_sfp-internal-activity-submissions_report"],
  "rep_sfp-internal-activity-submissions_report": ["rep_all_access"],
  "rep_sfp-internal-activity-submissions_scheduler": ["rep_sfp-internal-activity-submissions_report"],
  "rep_sfp-lead-gen_drilldown": ["rep_sfp-lead-gen_report"],
  "rep_sfp-lead-gen_export": ["rep_sfp-lead-gen_report"],
  "rep_sfp-lead-gen_no-email": ["rep_sfp-lead-gen_report"],
  "rep_sfp-lead-gen_report": ["rep_all_access"],
  "rep_sfp-lead-gen_scheduler": ["rep_sfp-lead-gen_report"],
  "rep_sfp-leads_drilldown": ["rep_sfp-leads_report"],
  "rep_sfp-leads_export": ["rep_sfp-leads_report"],
  "rep_sfp-leads_no-email": ["rep_sfp-leads_report"],
  "rep_sfp-leads_report": ["rep_all_access"],
  "rep_sfp-leads_scheduler": ["rep_sfp-leads_report"],
  "rep_sfp-links-clicked_drilldown": ["rep_sfp-links-clicked_report"],
  "rep_sfp-links-clicked_export": ["rep_sfp-links-clicked_report"],
  "rep_sfp-links-clicked_no-email": ["rep_sfp-links-clicked_report"],
  "rep_sfp-links-clicked_report": ["rep_all_access"],
  "rep_sfp-links-clicked_scheduler": ["rep_sfp-links-clicked_report"],
  "rep_sfp-submissions_export": ["rep_sfp-submissions_report"],
  "rep_sfp-submissions_no-email": ["rep_sfp-submissions_report"],
  "rep_sfp-submissions_report": ["rep_all_access"],
  "rep_sfp-submissions_scheduler": ["rep_sfp-submissions_report"],
};

export const missingDependencyRoles = (role:string, userRoles: string[]) => {
  const deps = roleDependencies[role];
  if(!deps){
    return [];
  }
  return deps.filter( d => !userRoles.includes(d));
}

export const tooltips = {
  "rep_all_access":
    "Enabling access to application reports.smartbrandscompany.com",
  "rep_all_lm-admin-access":
    "Access to all LeadMark reports with all priviliges set on",
  "rep_all_ta-admin-access":
    "Access to all TradersAgency reports with all priviliges set on",
  "rep_all_tg-admin-access":
    "Access to all TrafficGrid reports with all priviliges set on",
  "rep_all_sfp-admin-access":
    "Access to all Smart Financial Publishing reports with all priviliges set on",
};
